import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppPreloadingStrategy, UnifiedLoginGuard } from '@monorepo/services';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./app-shell/app-shell.module').then((m) => m.AppShellModule),
    canActivate: [UnifiedLoginGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: AppPreloadingStrategy })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
